import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 30px;
  padding: 35px 28px;
  background: #ffffffcc;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  box-shadow:
    0px 8px 10px -6px #0000001a,
    0px 20px 25px -5px #0000001a;
  justify-content: center;
  max-width: 866px;
`;

export const AssignmentCard = styled.div`
  flex: 1;
  height: 134px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  border: ${(props) => (props.$active ? '1.5px solid #2D6CDF' : '1px solid #FFFFFFCC')};
  background: #ffffff99;
  box-shadow:
    0px 3.3px 4.94px -3.3px #0000001a,
    0px 8.24px 12.36px -2.47px #0000001a;
  &:hover {
    border-color: #3b71ca;
    transform: translateY(-2px);
  }
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
  color: ${(props) => (props.$active ? '#2D6CDF' : '#000000')};
`;

export const CardDescription = styled.p`
  font-size: 15px;
  text-align: center;
  color: ${(props) => (props.$active ? '#2D6CDF' : '#6c757d')};
  opacity: ${(props) => (props.$active ? 0.9 : 1)};
`;

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 35px;
  margin-top: 40px;
  padding: 0 10px;
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StepNumber = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-weight: bold;
  font-size: 16px;
  background: ${(props) =>
    props.$active ? 'linear-gradient(62.4deg, #51A2FF 10.63%, #2B7FFF 112.83%)' : '#F1F5F9'};
  color: ${(props) => (props.$active ? '#FFFFFF' : '#90A1B9')};
  box-shadow: ${(props) =>
    props.$active
      ? '0px 3px 4.5px -3px #0000001A,0px 7.5px 11.25px -2.25px #0000001A'
      : '0px 2.92px 4.38px -2.92px #0000001A,0px 7.29px 10.94px -2.19px #0000001A'};
`;

export const StepLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => (props.$active ? '#0F172B' : '#90A1B9')};
`;

export const StepDivider = styled.div`
  width: 20px;
  height: 4px;
  background: #e2e8f0;
`;
export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 40px;
  padding: 0 5px;
  button:last-child {
    background: linear-gradient(180deg, #296bcd 0%, #245499 100%);
    box-shadow:
      0px 4px 6px -4px #0000001a,
      0px 10px 15px -3px #0000001a;
    border-radius: 8px;
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    width: ${(props) => (props.$isLastStep ? 'fit-content' : '185px')};
  }
  button:first-child {
    background: #ffffff;
    box-shadow:
      0px 1px 2px -1px #0000001a,
      0px 1px 3px 0px #0000001a;
    border: 2px solid #e2e8f0;
    font-weight: 600;
    font-size: 16px;
    color: #314158;
    width: 115px;
  }
`;
export const Icon = styled.img`
  order: ${(props) => (props.$isLastStep ? -1 : 0)};
`;

export const StepperContainer1 = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 35px;
  margin-top: 40px;
  padding: 0 10px;
  margin: 25px;
`;

export const FooterContainer1 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 40px;
  padding: 0 5px;
  button:last-child {
    background: linear-gradient(180deg, #296bcd 0%, #245499 100%);
    box-shadow:
      0px 4px 6px -4px #0000001a,
      0px 10px 15px -3px #0000001a;
    border-radius: 8px;
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    width: ${(props) => (props.$isLastStep ? 'fit-content' : '185px')};
  }
  button:first-child {
    background: #ffffff;
    box-shadow:
      0px 1px 2px -1px #0000001a,
      0px 1px 3px 0px #0000001a;
    border: 2px solid #e2e8f0;
    font-weight: 600;
    font-size: 16px;
    color: #314158;
    width: 115px;
  }
`;
